module.exports = __webpack_public_path__ + "img/x2.57206745.jpg";